import {Observable} from 'rxjs';
import {ofType} from 'redux-observable';
import {catchError, flatMap, mergeMap} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import * as BillPayerEntitiesActions from 'web-app/react/entities/bill-payers/actions';
import * as ChildEntitiesActions from 'web-app/react/entities/children/actions';
import * as InstitutionEntitiesActions from 'web-app/react/entities/institutions/actions';
import * as AccountItemEntitiesActions from 'web-app/react/entities/account-items/actions';

import * as Actions from './actions';
import * as Api from './api';

const fetchAll = action$ =>
    action$.pipe(
        ofType(Actions.fetchAll.type),
        mergeMap(() =>
            Api.fetchAllBalances().pipe(
                flatMap(response => {
                    const fetchBalanceActions = response.billPayers
                        .map(billPayer =>
                            AccountItemEntitiesActions.fetchBillPayerBalance.action(
                                billPayer.institutionId,
                                billPayer.billPayerId,
                            ),
                        )
                        .toArray();

                    return [
                        BillPayerEntitiesActions.fetchAllSuccess.action({billPayers: response.billPayers}),
                        ChildEntitiesActions.fetchAllSuccess.action(response.children),
                        InstitutionEntitiesActions.fetchAllSuccess.action(response.institutions),

                        Actions.fetchAllSuccess.action({billPayers: response.billPayers}),
                    ].concat(fetchBalanceActions);
                }),
                catchError(e => Observable.of(Actions.fetchAllFailed.action(e))),
            ),
        ),
    );

export default combineEpics(fetchAll);
